import { jsx as _jsx } from "react/jsx-runtime";
import { observer } from "mobx-react";
import { addDisplayName } from "../Infra/display-name";
import { DocumentRetrievalViewModel, DocumentRetrievalStep } from "./DocumentRetrievalViewModel";
import { ProgressLoadingScreen } from "./ProgressLoadingScreen";
import { DocumentRetrievalRecordsNotFound } from "./DocumentRetrievalRecordsNotFound";
import { DocumentRetrievalContinueWithoutSharing } from "./DocumentRetrievalContinueWithoutSharing";
import { DocumentRetrievalReviewAndShare } from "./DocumentRetrievalReviewAndShare";
import { DocumentRetrievalHURLoading } from "./DocumentRetrievalHURLoading";
import { DocumentRetrievalLoginLocation } from "./DocumentRetrievalLoginLocation";
import { DocumentRetrievalSpecificLocationLogin } from "./DocumentRetrievalSpecificLocationLogin";
import { useViewModel } from "./useViewModel";
import { DocumentRetrievalTechnicalErrorView } from "./DocumentRetrievalTechnicalErrorView";
import { LoadingPlaceholder } from "./LoadingPlaceholder";
import { DocumentRetrievalDocumentSelectionView } from "./DocumentRetrievalDocumentSelectionView";
import { DocumentRetrievalAddProviderView } from "./DocumentRetrievalAddProviderView";
import { spinner } from "./Spinner";
import { DocumentRetrievalResultsFoundList } from "./DocumentRetrievalRecordsFoundList";
export const DocumentRetrievalView = observer((props) => {
    var _a;
    const model = useViewModel(DocumentRetrievalViewModel, props.container);
    if (props.stepToShow) {
        model.uiState.stepToShow = props.stepToShow;
    }
    model.onRecordsShared = props.onRecordsShared;
    if (props.staticRetrievalData) {
        model.uiState.isStatic = true;
        model.uiState.staticRetrievalData = props.staticRetrievalData;
    }
    else {
        model.uiState.patientId = (_a = props.patientId) !== null && _a !== void 0 ? _a : null;
        model.uiState.studyId = props.studyId;
    }
    return renderStepContent(model.currentStep);
    function renderStepContent(step) {
        switch (step) {
            case DocumentRetrievalStep.RESTORING_SESSION:
                return renderRestoringStateScreen();
            case DocumentRetrievalStep.LOADING:
                return renderLoadingScreen();
            case DocumentRetrievalStep.TECHNICAL_ERROR:
                return renderTechnicalErrorScreen();
            case DocumentRetrievalStep.RECORDS_NOT_FOUND:
                return renderRecordsNotFoundScreen();
            case DocumentRetrievalStep.REVIEW_AND_SHARE:
                return renderReviewLocationsScreen();
            case DocumentRetrievalStep.CONTINUE_WITHOUT_SHARING:
                return renderContinueWithoutSharingScreen();
            case DocumentRetrievalStep.LOCATION_LOGIN:
                return renderLocationLoginScreen();
            case DocumentRetrievalStep.SPECIFIC_LOCATION_LOGIN:
                return renderSpecificLocationLoginScreen();
            case DocumentRetrievalStep.HUR_LOADING:
                return renderHurLoadingScreen();
            case DocumentRetrievalStep.DOCUMENT_SELECTION:
                return renderDocumentSelectionScreen();
            case DocumentRetrievalStep.ADD_PROVIDER:
                return renderAddProviderScreen();
            case DocumentRetrievalStep.RECORDS_FOUND_LIST:
                return renderRecordsFoundListScreen();
            default:
                return renderReviewLocationsScreen();
        }
    }
    function renderRestoringStateScreen() {
        return _jsx(LoadingPlaceholder, { w: 10, h: 60, center: true });
    }
    function renderLoadingScreen() {
        if (model.isAddRecordLocationsDirectlyRequested) {
            return _jsx(LoadingPlaceholder, { w: 10, h: 60, center: true });
        }
        if (model.useTefca) {
            return _jsx(ProgressLoadingScreen, { title: model.loadingTitle, subtitle: model.loadingSubTitle, progress: model.loadingProgress });
        }
        else {
            return spinner();
        }
    }
    function renderTechnicalErrorScreen() {
        return _jsx(DocumentRetrievalTechnicalErrorView, { model: model, container: props.container });
    }
    function renderRecordsNotFoundScreen() {
        return (_jsx(DocumentRetrievalRecordsNotFound, { animate: model.animate, isIAS: model.isIAS, isAIFlow: model.isAIFlow, onAddProviders: () => model.addProvidersFromRecordsNotFound(), onContinueWithoutSharing: () => model.continueFromRecordsNotFound() }));
    }
    function renderReviewLocationsScreen() {
        return _jsx(DocumentRetrievalReviewAndShare, { model: model, container: props.container });
    }
    function renderRecordsFoundListScreen() {
        return _jsx(DocumentRetrievalResultsFoundList, { model: model, container: props.container });
    }
    function renderDocumentSelectionScreen() {
        return _jsx(DocumentRetrievalDocumentSelectionView, { model: model, container: props.container });
    }
    function renderAddProviderScreen() {
        return _jsx(DocumentRetrievalAddProviderView, { model: model, container: props.container });
    }
    function renderContinueWithoutSharingScreen() {
        return (_jsx(DocumentRetrievalContinueWithoutSharing, { fastenPublicId: model.fastenPublicId, fastenPatientId: model.fastenPatientId, isStatic: model.uiState.isStatic, isIAS: model.isIAS, onConfirmContinue: async () => await model.confirmContinueWithoutSharing(), onAddAnotherClicked: props.onAddAnotherClicked, organizationName: model.organizationName, isAIFlow: model.isAIFlow, aiToolName: model.aiToolName, container: props.container, model: model }));
    }
    function renderLocationLoginScreen() {
        return _jsx(DocumentRetrievalLoginLocation, { model: model });
    }
    function renderSpecificLocationLoginScreen() {
        return _jsx(DocumentRetrievalSpecificLocationLogin, { model: model, container: props.container });
    }
    function renderHurLoadingScreen() {
        return _jsx(DocumentRetrievalHURLoading, { model: model });
    }
});
addDisplayName(DocumentRetrievalView, "DocumentRetrievalView");
